import { Box, Button, Drawer, TextField, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { useCreateVoucherDrawer } from './useCreateVoucherDrawer';

interface CreateVoucherDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: string | null;
}

export const CreateVoucherDrawer: FunctionComponent<
  CreateVoucherDrawerProps
> = ({ isOpen, onClose, eventId }) => {
  const { errors, onSubmit, register } = useCreateVoucherDrawer(
    eventId,
    onClose,
  );

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Créer un code de réduction</Typography>
        <form onSubmit={onSubmit}>
          <TextField
            margin="normal"
            fullWidth
            id="code"
            label="Code (Le moins facile à deviner possible)"
            placeholder='Ex: "Tr0yes133P0utres"'
            autoFocus
            type="text"
            {...register('code')}
            helperText={
              errors.code?.message ? (
                <Typography component="p" variant="body2" color="error.main">
                  {errors.code.message}
                </Typography>
              ) : null
            }
          />
          <TextField
            margin="normal"
            fullWidth
            id="amount"
            label="Réduction en centimes"
            placeholder='Ex: "200" pour 2.00€'
            autoFocus
            type="number"
            {...register('amount')}
            helperText={
              errors.amount?.message ? (
                <Typography component="p" variant="body2" color="error.main">
                  {errors.amount.message}
                </Typography>
              ) : null
            }
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Créer
          </Button>
        </form>
      </Box>
    </Drawer>
  );
};
